var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFwuAvailable = function SvgIconFwuAvailable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.929 17.733a.5.5 0 0 1 0 .5l-1.497 2.6a.5.5 0 0 1-.87 0l-1.499-2.599a.5.5 0 0 1 .433-.75h1.002v-4.4a.5.5 0 1 1 1 0v4.4h.998a.5.5 0 0 1 .433.249"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.498 14.584v1h4.5a4 4 0 0 0 1.247-7.802 6.503 6.503 0 0 0-12.433-.198h-.814a4 4 0 0 0 0 8h4.5v-1h-4.5a3 3 0 0 1 0-6h1.19a.5.5 0 0 0 .483-.375 5.503 5.503 0 0 1 10.677.092.5.5 0 0 0 .367.37 3.001 3.001 0 0 1-.717 5.913z"
  })));
};
export default SvgIconFwuAvailable;